import { memo } from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import type { DataTableFilterActions } from "../core/types";
import { type Locale, t } from "../lib/i18n";

interface FilterActionsProps {
  hasFilters: boolean;
  actions?: DataTableFilterActions;
  locale?: Locale;
}

export const FilterActions = memo(__FilterActions);
function __FilterActions({ hasFilters, actions, locale = "en" }: FilterActionsProps) {
  return (
    <Button
      className={cn("rounded-full", !hasFilters && "hidden")}
      size={"sm"}
      variant="ghost"
      onClick={actions?.removeAllFilters}
    >
      <span className="hidden md:block">{t("clear", locale)}</span>
    </Button>
  );
}
